import { render, staticRenderFns } from "./alterarSenha.vue?vue&type=template&id=8ff0d976"
import script from "./alterarSenha.vue?vue&type=script&lang=ts"
export * from "./alterarSenha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports